import { makeStyles, createStyles, Card, CardContent } from '@material-ui/core';


let useStyles = makeStyles(() =>
    createStyles({
        root: {
            width: '100%',
            overflowX: 'auto',
        },
        content: {
            padding: 0
        },
        inner: {
            minWidth: 700
        }
    })
);

let PageContent = ({ children }: any) => {
    let classes = useStyles();


    return (
        <div className={classes.root}>
            <Card>
                <CardContent className={classes.content}>
                    <div className={classes.inner}>
                        {children}
                    </div>
                </CardContent>
            </Card>
        </div>
    );
}

export default PageContent;